import { observer } from "mobx-react-lite";
import * as React from "react";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import NGAlert from "../../../../newcomponents/alert";
import { ExternalLink } from "../../../../newcomponents/table/components/ExternalLink";
import { DOCS_URL } from "../../../../envVariables";

interface Props {
  mk8sDraft: Mk8sDraftMobx;
}
const Mk8sCreateAddonsAWSWorkloadIdentityRaw: React.FC<Props> = ({ mk8sDraft }) => {
  return (
    <div>
      <div>AWS Workload Identity</div>
      <NGAlert
        className="mt-4"
        type={"info"}
        title="Documentation"
        render={() => {
          return (
            <div className="flex items-end gap-1">
              <ExternalLink url={`${DOCS_URL}/mk8s/add-ons/aws_workload_identity`} label={`Click here`} disableCopy />
              <div>for learning how to configure the addon.</div>
            </div>
          );
        }}
      />
    </div>
  );
};

export const Mk8sCreateAddonsAWSWorkloadIdentity = observer(Mk8sCreateAddonsAWSWorkloadIdentityRaw);
